export const saveUser = (token, user) => {
  localStorage.setItem("eshara_token", token);
  localStorage.setItem("eshara_user", JSON.stringify(user));
};

export const getToken = () => {
  return localStorage.getItem("eshara_token");
};

export const getUser = () => {
  const user = localStorage.getItem("eshara_user");
  return user ? JSON.parse(user) : null;
};

export const isLoggedIn = () => {
  return !!getToken();
};

export const logout = async () => {
  const token = getToken();
  try {
    if (token) {
      await fetch('https://anees-erp-cloud.anees-erp-ahmed.workers.dev/auth/logout', {
        method: 'POST',
        headers: { Authorization: `Bearer ${token}` }
      });
    }
  } catch (_) {}
  localStorage.removeItem("eshara_token");
  localStorage.removeItem("eshara_user");
};